import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'a1-indicator',
  styleUrl: 'a1-indicator.scss',
  scoped: true,
})
export class A1Indicator {
  /**
   * Number displayed inside Indicator.
   *
   * If <= 0 it shows Indicator as an empty colored point.
   */
  @Prop({ reflect: true }) count: number = 0;

  /**
   * Limit the number of digits to be displayed.
   *
   * If > 0 it shows the selected limit value and plus symbol when the counter value reaches the limit.
   *
   * If == 0 there is no limit value for the counter.
   */
  @Prop({ reflect: true }) maxDigits: 0 | 1 | 2 | 3 | 4 = 0;

  /**
   * Indicator type.
   */
  @Prop({ reflect: true }) type: 'critical' | 'warning' | 'positive' | 'info' = 'critical';

  private getLimitedCount() {
    const maxValueMapping = [0, 9, 99, 999, 9999];
    let limit = this.count;
    if (this.maxDigits > 0) {
      const maxValue = maxValueMapping[this.maxDigits] ?? maxValueMapping[maxValueMapping.length - 1];
      limit = Math.min(this.count, maxValue);
    }
    return this.count > limit ? `${limit}+` : `${limit}`;
  }

  render() {
    const classes = {
      indicator: true,
      [this.type]: true,
      count: this.count > 0,
      countless: this.count <= 0,
    };

    return <div class={classes}>{this.count > 0 ? this.getLimitedCount() : null}</div>;
  }
}
